import { store } from 'store'

import { refreshToken } from '../api'
import { AuthError, AuthStatus, authActions } from '../redux/authSlice'

const tokenBadReq = () => {
  store.dispatch(
    authActions.setAuthInfo({
      status: AuthStatus.guest,
      error: AuthError.tokenExpired,
      accessToken: null,
      refreshToken: null,
    }),
  )
  store.dispatch(authActions.setClientTypeInfo(null))
}

let refreshPromise: Promise<boolean> | null = null

// обновления токенов доступа

export const refreshTokenAction = async (): Promise<boolean> => {
  // Если уже идёт рефреш — возвращаем тот же промис
  if (refreshPromise) return refreshPromise

  refreshPromise = (async () => {
    try {
      const token = store.getState().auth.authInfo.refreshToken
      if (!token) {
        tokenBadReq()
        return false
      }

      const { data } = await refreshToken(token)
      if (!data?.accessToken) {
        tokenBadReq()
        return false
      }

      store.dispatch(
        authActions.setAuthInfo({
          accessToken: data.accessToken,
          refreshToken: data.refreshToken,
        }),
      )
      return true
    } catch (error) {
      tokenBadReq()
      return false
    } finally {
      refreshPromise = null
    }
  })()

  return refreshPromise
}
